import type {JsonSchema} from '@jsonforms/core'

import {StepTypes} from '../../../../types'

import fallbackScriptJsonSchema from './JobStep/JobStepJsonForm/jsonFormJsonSchema/script.json'

export function getStepRunnerJsonSchema(
  jobRunners: Record<string, {jsonSchema: JsonSchema; uiSchema?: unknown}> | undefined,
  type?: string,
): JsonSchema | undefined {
  const normalizedType = type?.toLowerCase()
  const runnerJsonSchema =
    normalizedType != null ? jobRunners?.[normalizedType]?.jsonSchema : undefined

  if (!runnerJsonSchema && normalizedType === StepTypes.CLI) {
    return fallbackScriptJsonSchema
  }

  return runnerJsonSchema
}

export function getSchemaDefaults(schema: JsonSchema | undefined): Record<string, unknown> {
  const defaults: Record<string, unknown> = {}
  const properties = schema?.properties

  if (!properties) {
    return defaults
  }

  for (const [key, prop] of Object.entries(properties)) {
    if (typeof prop === 'object' && prop?.default !== undefined) {
      defaults[key] = prop.default
    }
  }

  return defaults
}
